module.exports = __webpack_public_path__ + "img/brutto.de8ca045.svg";